export const tabs = {
	productDetails: {
		label: "Détails du produit",
		title: "Détails du produit",
		subtitle: "Informations générales, tarification et stock",
	},
	storages: {
		label: "Stocks",
		title: "Stocks",
		subtitle: "Voir tous les stocks liés à ce produit",
		table: {
			empty: "Aucun stock lié",
			columns: {
				storage: "Stock",
				quantity: "Quantité",
				value: "Valeur en stock",
			},
		},
	},
	kardex: {
		label: "Fiche Kardex",
		title: "Fiche Kardex",
		subtitle: "La fiche Kardex représente le stock et les mouvements d'un article.",
	},
	fiscalData: {
		label: "Données fiscales",
		title: "Données fiscales",
		subtitle: "Informations fiscales du produit",
	},
	technicalSheet: {
		label: "Fiche technique",
		title: "Fiche technique",
		subtitle: "Composition et ingrédients du produit",
	},
	bars: {
		label: "Bars",
		title: "Bars",
		subtitle: "Paramètres des bars et secteurs",
	},
	mountableProduct: {
		label: "Produit montable",
		title: "Produit montable",
		subtitle:
			"Les produits montables permettent au client final d'ajouter des ingrédients ou de personnaliser le produit",
	},
	qrcode: {
		label: "QR Code",
		title: "QR Code",
	},
};
